import {CubeDefinitionData} from "../../framework/bi/cube-definition.data";
import {MdxMemberUtil} from "../../framework/bi/mdx-member-util";

export class BIAttribute {

    public static readonly DIMENSION_TYPE = "dimension";
    public static readonly MEASURE_TYPE = "measure";

    public static buildAttributesFromCube(cubeDefinitionData: CubeDefinitionData): BIAttribute[] {
        const attributes: BIAttribute[] = [];
        cubeDefinitionData.attributes.forEach((t: string) => {
            const mandatory: boolean = cubeDefinitionData.mandatoryDimension != null && t.startsWith("[" + cubeDefinitionData.mandatoryDimension + "]");
            attributes.push(new BIAttribute(t, "wbo.bi.search.field." + t + ".label", MdxMemberUtil.getHierarchy(t), BIAttribute.DIMENSION_TYPE, false, mandatory));
        });

        if (cubeDefinitionData.measures) {
            cubeDefinitionData.measures.forEach((m: string) => {
                attributes.push(new BIAttribute(m, "wbo.bi.search.field." + m + ".label", m, BIAttribute.MEASURE_TYPE, false, false));
            });
        }

        return attributes;
    }

    constructor(public id: string, public label: string, public value: string, public type: string, public used: boolean, public mandatory: boolean) {
    }

    get types(): string[] {
        return [this.type];
    }

    get icon(): string {
        return this.type === BIAttribute.DIMENSION_TYPE ? "axes" : "sum";
    }
}
